import { useRating } from '@risksmart-app/components/src/hooks/useRating';
import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import { useMemo } from 'react';
import {
  getAllContributorsCellValue,
  getAllOwnersCellValue,
  getAllViewersCellValue,
} from 'src/rbac/contributorHelper';

import { collectAssessedItemTitles } from '@/utils/assessedItems';
import { getFriendlyId } from '@/utils/friendlyId';

import type { AssessmentFields, AssessmentRegisterFields } from './types';

export const useLabelledFields = (records: AssessmentFields[] | undefined) => {
  const { getLabel: getStatusLabel } = useRating('assessment_status');
  const { getLabel: getOutcomeLabel } = useRating('assessment_outcome');
  const labelledFields = useMemo<AssessmentRegisterFields[] | undefined>(() => {
    return records?.map((d) => {
      return {
        ...d,
        SequentialIdLabel: getFriendlyId(
          Parent_Type_Enum.Assessment,
          d.SequentialId
        ),
        Title: d.Title || '-',
        CreatedBy: d.CreatedByUser || '-',
        ModifiedBy: d.ModifiedByUser || '-',
        allOwners: getAllOwnersCellValue(d),
        allContributors: getAllContributorsCellValue(d),
        allViewers: getAllViewersCellValue(d),
        completedByUser: d.completedByUser,
        Status: d.Status,
        StatusLabelled: getStatusLabel(d.Status),
        Outcome: d.Outcome,
        OutcomeLabelled: getOutcomeLabel(d.Outcome),
        AssessedItems: collectAssessedItemTitles(
          d.assessedItems,
          [
            (ai) => {
              const doc = ai.documentAssessmentResult?.parents?.[0]?.document;

              return doc && { id: doc.Id, title: doc.Title };
            },
            (ai) => {
              const risk = ai.riskAssessmentResult?.parents?.[0]?.risk;

              return risk && { id: risk.Id, title: risk.Title };
            },
            (ai) => {
              const obligation =
                ai.obligationAssessmentResult?.parents?.[0]?.obligation;

              return (
                obligation && { id: obligation.Id, title: obligation.Title }
              );
            },
          ],
          { dedupe: true, sort: true }
        ),
      };
    });
  }, [records, getStatusLabel, getOutcomeLabel]);

  return labelledFields;
};
